import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import { httpOk, POST, PUT, GET, FILE } from 'helpers/api'
import { formatMoney, notify } from 'helpers/helpers'
import useFileDrop from 'pages/parts/useFileDrop'

function Index() {
	const { t } = useTranslation()

	const [data, setData] = useState([])
	const [halls, setHalls] = useState([])
	const [fiscalProviders, setFiscalProviders] = useState([])
	const [selectedItem, setSelectedItem] = useState({})
	const [showModal, setShowModal] = useState(false)

	async function searchWithFilter() {
		var filterUrl = "/terminals"

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) setData(response.data)
	}

	async function createUpdate(e) {
		e.preventDefault()

		var response;
		if (selectedItem.id) {
			response = await PUT('/terminals', selectedItem, { loader: true })
		} else {
			response = await POST('/terminals', selectedItem, { loader: true })
		}

		if (httpOk(response)) {
			searchWithFilter()
			toggleModal()
		}
	}

	async function uploadImageFile(file) {
		if (!file) return

		if (!file.type?.startsWith('image/')) {
			notify(t('image2'))
			return
		}

		let formData = new FormData();
		formData.append("id", data.id);
		formData.append("image", file);
		formData.append("db_name", 'terminals');
		formData.append("column_name", 'image');
		formData.append("path", 'terminals');

		var response
		if (!data.id) {
			response = await FILE('/upload-image', formData, {}, { loader: true });
		} else {
			response = await FILE(`/update-image`, formData, {}, { loader: true });
		}

		if (httpOk(response)) setSelectedItem({ ...selectedItem, 'image': response.data.url })
	}

	async function fileUpload(e) {
		await uploadImageFile(e.target.files[0])
	}

	const { dropProps, dropStyle } = useFileDrop(uploadImageFile)

	function toggleModal(bool = false, item = {}) {
		setSelectedItem(item)
		setShowModal(bool)
	}

	async function getHalls() {
		const response = await GET(`/helper/halls`)
		if (httpOk(response)) setHalls(response.data)
	}

	async function getFiscalProviders() {
		const response = await GET('/helper/fiscal-prodviders')
		if (httpOk(response)) setFiscalProviders(response.data)
	}

	useEffect(() => {
		getHalls()
		getFiscalProviders()
		searchWithFilter()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('terminals')} [{formatMoney(data?.total)}]
				</h4>
				<div className="d-flex d-none">
					<button className="btn-rounded btn btn-primary"
						onClick={() => toggleModal(true)}>
						{t('create')}
					</button>
				</div>
			</div>

			<div className="card">
				<div className="card-body">

					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '15%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }}>{t('login')}</th>
									<th style={{ 'width': '15%' }}>{t('password')}</th>
									<th style={{ 'width': '70%' }}></th>
									<th style={{ 'minWidth': '55px' }} className="text-center td-ellipsis"
										title={t('fiscalization')}>
										{t('fiscalization')}
									</th>
									<th style={{ 'minWidth': '55px' }} className="text-center td-ellipsis"
										title={t('image2')}>
										{t('image2')}
									</th>
									<th style={{ 'width': '15%' }} className="text-center">{t('status')}</th>
									<th style={{ 'minWidth': '33px' }}></th>
								</tr>
							</thead>
							<tbody>
								{data?.data?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{item.row_number}</td>
										<td>
											<span className="link-primary" style={{ 'cursor': 'pointer' }}
												onClick={() => toggleModal(true, item)}>{item.name}</span>
										</td>
										<td>{item.terminal_login}</td>
										<td>{item.password}</td>
										<td></td>
										<td className="text-center">
											{!item.is_fiscal &&
												<span className="bg-danger bg-border"></span>
											}
											{item.is_fiscal &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td className="text-center">
											{!item.image &&
												<span className="bg-danger bg-border"></span>
											}
											{item.image &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td className="text-center">
											{!item.status &&
												<span className="bg-danger bg-border"></span>
											}
											{item.status &&
												<span className="bg-primary bg-border"></span>
											}
										</td>
										<td>
											<div className="table-dropdown">
												<Dropdown id={`dropdown-${index}`}>
													<Dropdown.Toggle variant="outline-primary">
														<i className="uil uil-ellipsis-v"></i>
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<div className="table-dropdown-item"
															onClick={() => toggleModal(true, item)}>
															<i className="uil-edit-alt"></i>
															{t('edit')}
														</div>
													</Dropdown.Menu>
												</Dropdown>
											</div>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			{/* MODAL */}
			<Modal
				show={showModal}
				animation={false}
				dialogClassName="update-modal-width"
				centered
				onHide={() => toggleModal()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{selectedItem.id ?
							<>{t('edit')}</>
							:
							<>{t('create')}</>
						}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={createUpdate} autoComplete="off">
						<div className="form-group">
							<label>{t('name2')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="name"
								autoFocus
								value={selectedItem.name ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'name': e.target.value })} />
						</div>
						<div className="form-group">
							<label>{t('password')}<span className="required-mark">*</span></label>
							<input type="text" className="form-control" name="password"
								value={selectedItem.password ?? ''}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'password': e.target.value })} />
						</div>

						<div className="form-group">
							<label>{t('halls')}</label>
							<Select
								isMulti
								isClearable
								options={halls}
								value={selectedItem.halls}
								onChange={(options) => setSelectedItem({ ...selectedItem, 'halls': options ? options : null })}
								placeholder=""
								noOptionsMessage={() => t('list_empty')}
								getOptionLabel={(option) => option.name}
								getOptionValue={(option) => option.id}
							/>
						</div>

						<div className="form-group">
							<label>{t('fiscalization')}</label>
							<div className="d-flex justify-content-between mb-2">
								<div className="d-flex gap-3">
									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'is_fiscal': true })}
											style={{ 'backgroundColor': selectedItem.is_fiscal ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({ ...selectedItem, 'is_fiscal': true })}>
											{t('yes')}
										</span>
									</div>

									<div className="form-check p-0">
										<div className="radio-round"
											onClick={() => setSelectedItem({ ...selectedItem, 'is_fiscal': false })}
											style={{ 'backgroundColor': !selectedItem.is_fiscal ? 'black' : '' }}>
										</div>
										<span onClick={() => setSelectedItem({
											...selectedItem,
											'is_fiscal': false,
											'fiscal_provider_id': null,
											'fiscal_serial_number': null,
										})}>
											{t('no')}
										</span>
									</div>
								</div>
							</div>
						</div>

						{selectedItem.is_fiscal &&
							<>
								<div className="form-group">
									<label>{t('type')}<span className="required-mark">*</span></label>
									<Select
										isClearable
										options={fiscalProviders}
										value={fiscalProviders.find(option => option.id === selectedItem.fiscal_provider_id) || ''}
										onChange={(option) => setSelectedItem({ ...selectedItem, 'fiscal_provider_id': option ? option.id : null })}
										placeholder=""
										noOptionsMessage={() => t('list_empty')}
										getOptionLabel={(option) => option.name}
										getOptionValue={(option) => option.id}
									/>
								</div>
								<div className="form-group">
									<label>{t('fiscal_module')}<span className="required-mark">*</span></label>
									<input type="text" className="form-control" name="fiscal_serial_number"
										disabled={!selectedItem.is_fiscal}
										value={selectedItem.fiscal_serial_number ?? ''}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'fiscal_serial_number': e.target.value })} />
								</div>
							</>
						}

						<div className="con-upload" {...dropProps}>
							<div className="con-img-upload">
								{selectedItem.image &&
									<div className="img-upload" style={dropStyle}>
										<button type="button" className="btn-x-file"
											onClick={() => setSelectedItem({ ...selectedItem, 'image': '' })}>
											<i className="uil-times"></i>
										</button>
										<img src={`https://backend.mison.uz/uploads/terminals/${selectedItem.image}`}
											style={{ maxWidth: 'none', maxHeight: '100%' }} alt={selectedItem.image} />
									</div>
								}
								{!selectedItem.image &&
									<div className="con-input-upload" style={dropStyle}>
										<input type="file" name="image" onChange={(e) => fileUpload(e)} />
										<span className="text-input fz14">
											{t('image2')}
										</span>
									</div>
								}
							</div>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100"
								onClick={() => toggleModal()}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Index
